import { render, staticRenderFns } from "./productViewer.vue?vue&type=template&id=41ec45f1&scoped=true&"
import script from "./productViewer.vue?vue&type=script&lang=js&"
export * from "./productViewer.vue?vue&type=script&lang=js&"
import style0 from "./productViewer.vue?vue&type=style&index=0&id=41ec45f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ec45f1",
  null
  
)

export default component.exports